import { AxiosResponse } from 'axios';
import { axiosIntegration } from './lmsIntegrationAgent';

const responseBody = <T>(response: AxiosResponse<T>) => response.data;

export type SynthesiaSourceFilter = 'workspace' | 'my_videos' | 'shared_with_me';

export interface ISynthesiaListVideosResponse {
  videos?: unknown[];
  items?: unknown[];
  results?: unknown[];
  data?: {
    videos?: unknown[];
    items?: unknown[];
  };
  [key: string]: any;
}

const requests = {
  listVideos: <T>(ownerId: number, source?: SynthesiaSourceFilter, limit: number = 20, offset: number = 0) =>
    axiosIntegration
      .get<T>('/proxy/synthesia/list-videos', {
        params: {
          ownerId,
          limit,
          offset,
          ...(source ? { source } : {}),
        },
        headers: {
          Accept: 'application/json',
        },
      })
      .then(responseBody),
};

const videos = {
  list: (ownerId: number, source?: SynthesiaSourceFilter, limit?: number, offset?: number) => requests.listVideos<ISynthesiaListVideosResponse>(ownerId, source, limit ?? 20, offset ?? 0),
};

const agent = {
  videos,
};

export default agent;
